var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ModalAjoutProduitHM", {
        ref: "modalAjoutProduit",
        attrs: { paramModale: { modeAffichage: "ajoutProduit" } },
        on: {
          "produit-modifie": function($event) {
            return _vm.selectionNouveauProduitHM($event)
          }
        }
      }),
      _c("RechercheCompleteProduits", {
        ref: "recherche",
        attrs: {
          placeHolder: "Rechercher un produit...",
          ajoutActif: _vm.ajoutActif,
          selectionActive: false,
          fournisseurId: _vm.fournisseurId,
          chercherProduits: true,
          pourChoixIngredient: true,
          afficherPrix: false
        },
        on: {
          input: function($event) {
            return _vm.selectionProduit($event)
          },
          reset: function($event) {
            return _vm.reset()
          },
          ajouter: function($event) {
            return _vm.creationArticle()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }